<template>
    <div class="md-layout dashboard-page">
        <md-progress-spinner v-if="isLoading"
            md-mode="indeterminate"></md-progress-spinner>
        <template v-else>
            <!-- announcements -->
            <div class="announcements md-layout-item md-xlarge-size-66 md-large-size-66 md-medium-size-100"
                v-if="!isAdmin">
                <md-card md-with-hover>
                    <md-ripple>
                        <md-card-header>
                            <div class="md-title">
                                {{ $tc('posts.post', 2) }}
                            </div>
                        </md-card-header>
                        <md-divider></md-divider>
                        <md-card-content>
                            <b-carousel v-if="postsDataSource.length > 0"
                                id="carousel"
                                v-model="slide"
                                :interval="0"
                                controls
                                indicators>
                                <b-carousel-slide v-for="(post, indx) in postsDataSource"
                                    :key="post.post_id"
                                    :index="indx"
                                    :class="{ 'no-img': !post.picture_data }">
                                    <template v-slot:img>
                                        <div class="image-wrap">
                                            <div>
                                                <img :src="post.picture_data"
                                                    :alt="post.title">
                                            </div>
                                        </div>
                                    </template>
                                    <template v-slot:default>
                                        <h5>{{ post.title }}</h5>
                                        <p>{{ post.description }}</p>
                                        <a v-if="post.promotion_link"
                                            :href="post.promotion_link">Read more</a>
                                    </template>
                                </b-carousel-slide>
                            </b-carousel>
                        </md-card-content>
                    </md-ripple>
                </md-card>
            </div>
            <!-- first item -->
            <div class="md-layout-item md-xlarge-size-33 md-large-size-33 md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-card md-with-hover>
                    <md-ripple>
                        <md-card-header>
                            <div class="md-title">
                                {{ $tc('orders.order', 2) }}
                            </div>
                        </md-card-header>
                        <md-divider></md-divider>
                        <md-card-content>
                            <statistics-orders :admin="isAdmin"
                                v-if="isLogged"></statistics-orders>
                        </md-card-content>
                        <md-card-actions>
                            <md-button @click="toRoute('/orders')">
                                {{ $t('actions.manage') }}
                            </md-button>
                        </md-card-actions>
                    </md-ripple>
                </md-card>
            </div>
            <!-- second item -->
            <div class="md-layout-item md-xlarge-size-33 md-large-size-33 md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                v-if="isAdmin">
                <md-card md-with-hover>
                    <md-ripple>
                        <md-card-header>
                            <div class="md-title">
                                {{ $tc('organizations.organization', 2) }}
                            </div>
                        </md-card-header>
                        <md-divider></md-divider>
                        <md-card-content>
                            <statistics-organizations></statistics-organizations>
                        </md-card-content>
                        <md-card-actions>
                            <md-button @click="toRoute('/organizations')">
                                {{ $t('actions.manage') }}
                            </md-button>
                        </md-card-actions>
                    </md-ripple>
                </md-card>
            </div>
            <!-- third item -->
            <div class="md-layout-item md-xlarge-size-33 md-large-size-33 md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                v-if="isAdmin">
                <md-card md-with-hover>
                    <md-ripple>
                        <md-card-header>
                            <div class="md-title">
                                {{ $tc('products.product', 2) }}
                            </div>
                        </md-card-header>
                        <md-divider></md-divider>
                        <md-card-content>
                            <statistics-products></statistics-products>
                        </md-card-content>
                        <md-card-actions>
                            <md-button @click="toRoute('/products')">
                                {{ $t('actions.manage') }}
                            </md-button>
                        </md-card-actions>
                    </md-ripple>
                </md-card>
            </div>
            <!-- fourth item -->
            <div class="md-layout-item md-xlarge-size-33 md-large-size-33 md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                v-if="isAdmin">
                <md-card md-with-hover>
                    <md-ripple>
                        <md-card-header>
                            <div class="md-title">
                                {{ $tc('calibers.caliber', 2) }}
                            </div>
                        </md-card-header>
                        <md-divider></md-divider>
                        <md-card-content>
                            <statistics-calibers></statistics-calibers>
                        </md-card-content>
                        <md-card-actions>
                            <md-button @click="toRoute('/calibers')">
                                {{ $t('actions.manage') }}
                            </md-button>
                        </md-card-actions>
                    </md-ripple>
                </md-card>
            </div>
            <!-- fifth item -->
            <div class="md-layout-item md-xlarge-size-33 md-large-size-33 md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                v-if="isAdmin">
                <md-card md-with-hover>
                    <md-ripple>
                        <md-card-header>
                            <div class="md-title">
                                {{ $tc('units.unit', 2) }}
                            </div>
                        </md-card-header>
                        <md-divider></md-divider>
                        <md-card-content>
                            <statistics-units></statistics-units>
                        </md-card-content>
                        <md-card-actions>
                            <md-button @click="toRoute('/units')">
                                {{ $t('actions.manage') }}
                            </md-button>
                        </md-card-actions>
                    </md-ripple>
                </md-card>
            </div>
            <!-- sixth item -->
            <div class="md-layout-item md-xlarge-size-33 md-large-size-33 md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                v-if="isAdmin">
                <md-card md-with-hover>
                    <md-ripple>
                        <md-card-header>
                            <div class="md-title">
                                {{ $tc('posts.post', 2) }}
                            </div>
                        </md-card-header>
                        <md-divider></md-divider>
                        <md-card-content>
                            <statistics-posts></statistics-posts>
                        </md-card-content>
                        <md-card-actions>
                            <md-button @click="toRoute('/posts')">
                                {{ $t('actions.manage') }}
                            </md-button>
                        </md-card-actions>
                    </md-ripple>
                </md-card>
            </div>
        </template>
    </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import postsService from '@/components/posts/services/'
import StatisticsProducts from '@/components/dashboard/statistics/Products'
import StatisticsCalibers from '@/components/dashboard/statistics/Calibers'
import StatisticsOrganizations from '@/components/dashboard/statistics/Organizations'
import StatisticsOrders from '@/components/dashboard/statistics/Orders'
import StatisticsUnits from '@/components/dashboard/statistics/Units'
import StatisticsPosts from '@/components/dashboard/statistics/Posts'

const loadingKeys = {
    fetchingItem: 'fetching-item'
}

export default {
    name: 'Index',

    components: {
        StatisticsProducts,
        StatisticsCalibers,
        StatisticsOrganizations,
        StatisticsOrders,
        StatisticsUnits,
        StatisticsPosts
    },

    data () {
        return {
            postsDataSource: [],
            loadings: [],
            slide: 0
        }
    },

    computed: {
        isAdmin () {
            return this.$store.getters.user.role === 'ADMIN'
        },

        isLoading () {
            return this.isFetchingPosts
        },

        isFetchingPosts () {
            return !!this.loadings.filter(
                loading => loading.key === loadingKeys.fetchingItem
            ).length
        },

        isLogged () {
            return this.$store.getters.isLoggedIn
        }
    },

    methods: {
        async fetchActivePost () {
            _.fill(this.loadings, loadingKeys.fetchingItem)

            let self = this
            self.postsDataSource = []
            let today = new Date()
            let params = {
                filter: {
                    active: 1,
                    dateRange: {
                        column: 'expire_date',
                        begin: today,
                        end: new Date(today.getFullYear() + 1, today.getMonth(), today.getDate())
                    }
                }
            }
            let response = await postsService.retrieve(params)

            for (const post of response.data.results) {
                post.picture_data = await self.getBase64(post.picture_url)
            }
            self.postsDataSource = _.cloneDeep(response.data.results)

            _.pull(this.loadings, loadingKeys.fetchingItem)
        },

        async getBase64 (url) {
            return axios
                .get(url, {
                    responseType: 'arraybuffer',
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                })
                .then(response => {
                    let image = btoa(
                        new Uint8Array(response.data).reduce(
                            (data, byte) => data + String.fromCharCode(byte),
                            ''
                        )
                    )
                    return `data:${response.headers['content-type'].toLowerCase()};base64,${image}`
                })
        },

        toRoute (destination) {
            this.$router.push(destination)
        }
    },

    created () {
        if (!this.isAdmin) {
            this.fetchActivePost()
        }
    }
}
</script>
